import { Pipe, PipeTransform } from '@angular/core';
import { map, Observable } from 'rxjs';
import { FondsFilterSelections } from '../fonds-filters/fonds-filters';

@Pipe({
  name: 'getArraySelectionValue',
  standalone: true,
})
export class GetArraySelectionValuePipe implements PipeTransform {
  public transform(
    event: Observable<unknown>,
    key: string,
    option: string,
    selections: FondsFilterSelections
  ): Observable<boolean> {
    return event.pipe(
      map(() => {
        const selectedOption: unknown = selections[key];

        if (!selectedOption || !Array.isArray(selectedOption)) {
          return false;
        }

        return selectedOption.includes(option);
      })
    );
  }
}
